import { PayloadAction } from "@reduxjs/toolkit";
import { FinanceState } from "../../models/FinanceState";
import { GetFutureMoneyPayload } from "../../payload/GetFutureMoney/GetFutureMoneyPayload";

const getFutureMoneyFetch = (state: FinanceState, action: PayloadAction<GetFutureMoneyPayload>) => {
    state.isLoading = true;
}

export default getFutureMoneyFetch;